// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b6e05291","52":"c8e691a7","403":"bc19c2f7"}[chunkId] + ".chunk.js";
};